import { BASE_URL } from '../../constants/api';
import Fetch from '../fetch';
import Store from '../../stores/Store';

import CacheService from '../../utils/CacheService';

import type {
  FatcaQuestionType,
  FatcaFormControlType,
  FatcaAnswerOptionType,
  FormSelectOptionType,
  FormControlConfig,
} from '../../types/types';

export async function getFatcaQuestions(): Promise<FatcaFormControlType[]> {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/kycApi/loadFatchaQuestionAndAnswer?token=${token}`;

  const json = await CacheService(
    `kycApi/loadFatchaQuestionAndAnswer`,
    async () => {
      const json = await Fetch<FatcaQuestionType[]>(url, {
        method: 'GET',
        headers: {
          'x-token': store.get('x-token'),
          'x-csrf': store.get('x-csrf'),
          accept: 'application/json',
        },
      });

      const controls: FormControlConfig[] = json.map(
        (item: FatcaQuestionType) => {
          const options: FormSelectOptionType[] = item.answerOption.map(
            (item: FatcaAnswerOptionType) => {
              return {
                value: item.id,
                display: item.answerText,
              };
            }
          );

          options.unshift({ value: '', display: 'choose answer' });

          return {
            tag: 'select-no-float',
            value: item.answerId,
            name: item.questionId,
            label: item.questionText,
            validator: 'required=true',
            options,
          };
        }
      );

      controls.push({
        tag: 'hidden',
        value: json[0].questionaireId,
        name: 'questionaireId',
      });

      return controls;
    },
    {
      expiry: 10,
    }
  );

  return json;
}
